// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\MarineTrafficResult\ApiMarineTrafficResult.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { MarineTrafficServiceVessel, MarineTrafficServiceVesselData, MarineTrafficServiceVesselOptions } from 'data/models/MarineTrafficServiceVessel';
import { MarineTrafficVesselServiceQuery, MarineTrafficVesselServiceQueryData, MarineTrafficVesselServiceQueryOptions } from 'data/models/MarineTrafficVesselServiceQuery';

// MarineTrafficResultData is the class that MarineTrafficResult serializes to/from
export interface MarineTrafficResultData {
    Id : number;
	
    ServiceVessels : MarineTrafficServiceVesselData[] | null;
    VesselServiceQuery : MarineTrafficVesselServiceQueryData | null;
    VesselServiceQueryId : number | null;
	
    BreadthExtreme : string | null;
    Build : string | null;
    CallSign : string | null;
    CreatedOnUtc : /* ISO8601 */ string;
    DisplacementSummer : string | null;
    Draught : string | null;
    Flag : string | null;
    FuelConsumption : string | null;
    Guid : /* GUID */ string;
    IMO : string | null;
    LengthOverall : string | null;
    LiquidOil : string | null;
    Manager : string | null;
    MMSI : string | null;
    Name : string | null;
    Owner : string | null;
    PlaceOfBuild : string | null;
    RawXml : string | null;
    SpeedMax : string | null;
    SpeedService : string | null;
    SummerDwt : string | null;
    VesselType : string | null;
}

// MarineTrafficResultOptions is the class which may be passed to the MarineTrafficResult constructor to define optional initial data values
export interface MarineTrafficResultOptions {
    Id : number;
	
    ServiceVessels? : MarineTrafficServiceVesselOptions[] | null;
    VesselServiceQuery? : MarineTrafficVesselServiceQueryOptions | null;
    VesselServiceQueryId? : number | null;
	
    BreadthExtreme? : string | null;
    Build? : string | null;
    CallSign? : string | null;
    CreatedOnUtc? : /* ISO8601 */ string;
    DisplacementSummer? : string | null;
    Draught? : string | null;
    Flag? : string | null;
    FuelConsumption? : string | null;
    Guid? : /* GUID */ string;
    IMO? : string | null;
    LengthOverall? : string | null;
    LiquidOil? : string | null;
    Manager? : string | null;
    MMSI? : string | null;
    Name? : string | null;
    Owner? : string | null;
    PlaceOfBuild? : string | null;
    RawXml? : string | null;
    SpeedMax? : string | null;
    SpeedService? : string | null;
    SummerDwt? : string | null;
    VesselType? : string | null;
}

export class MarineTrafficResult {
    public Id : DataSignal<number>;
	
    public ServiceVessels : SDataArray<MarineTrafficServiceVessel>;
    public VesselServiceQuery : DataSignal<MarineTrafficVesselServiceQuery | null>;
    public VesselServiceQueryId : DataSignal<number | null>;
	
    public BreadthExtreme : DataSignal<string | null>;
    public Build : DataSignal<string | null>;
    public CallSign : DataSignal<string | null>;
    public CreatedOnUtc : DataSignal<TZDate>;
    public DisplacementSummer : DataSignal<string | null>;
    public Draught : DataSignal<string | null>;
    public Flag : DataSignal<string | null>;
    public FuelConsumption : DataSignal<string | null>;
    public Guid : DataSignal<string>;
    public IMO : DataSignal<string | null>;
    public LengthOverall : DataSignal<string | null>;
    public LiquidOil : DataSignal<string | null>;
    public Manager : DataSignal<string | null>;
    public MMSI : DataSignal<string | null>;
    public Name : DataSignal<string | null>;
    public Owner : DataSignal<string | null>;
    public PlaceOfBuild : DataSignal<string | null>;
    public RawXml : DataSignal<string | null>;
    public SpeedMax : DataSignal<string | null>;
    public SpeedService : DataSignal<string | null>;
    public SummerDwt : DataSignal<string | null>;
    public VesselType : DataSignal<string | null>;

    constructor();
    constructor(data : MarineTrafficResultOptions);
    constructor(data: MarineTrafficResultOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.ServiceVessels = SArray<MarineTrafficServiceVessel>([]);
        this.VesselServiceQuery = S.value<MarineTrafficVesselServiceQuery | null>(null);
        this.VesselServiceQueryId = jsonableObservable(S.value<number | null>(data && data.VesselServiceQueryId !== undefined ? data.VesselServiceQueryId : null));
	    
        this.BreadthExtreme = jsonableObservable(S.value<string | null>(data && data.BreadthExtreme !== undefined ? data.BreadthExtreme : null));
        this.Build = jsonableObservable(S.value<string | null>(data && data.Build !== undefined ? data.Build : null));
        this.CallSign = jsonableObservable(S.value<string | null>(data && data.CallSign !== undefined ? data.CallSign : null));
        this.CreatedOnUtc = jsonableObservable(S.value<TZDate>(data && data.CreatedOnUtc !== undefined ? new TZDate(data.CreatedOnUtc) : new TZDate(0), TZDate.eq));
        this.DisplacementSummer = jsonableObservable(S.value<string | null>(data && data.DisplacementSummer !== undefined ? data.DisplacementSummer : null));
        this.Draught = jsonableObservable(S.value<string | null>(data && data.Draught !== undefined ? data.Draught : null));
        this.Flag = jsonableObservable(S.value<string | null>(data && data.Flag !== undefined ? data.Flag : null));
        this.FuelConsumption = jsonableObservable(S.value<string | null>(data && data.FuelConsumption !== undefined ? data.FuelConsumption : null));
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.IMO = jsonableObservable(S.value<string | null>(data && data.IMO !== undefined ? data.IMO : null));
        this.LengthOverall = jsonableObservable(S.value<string | null>(data && data.LengthOverall !== undefined ? data.LengthOverall : null));
        this.LiquidOil = jsonableObservable(S.value<string | null>(data && data.LiquidOil !== undefined ? data.LiquidOil : null));
        this.Manager = jsonableObservable(S.value<string | null>(data && data.Manager !== undefined ? data.Manager : null));
        this.MMSI = jsonableObservable(S.value<string | null>(data && data.MMSI !== undefined ? data.MMSI : null));
        this.Name = jsonableObservable(S.value<string | null>(data && data.Name !== undefined ? data.Name : null));
        this.Owner = jsonableObservable(S.value<string | null>(data && data.Owner !== undefined ? data.Owner : null));
        this.PlaceOfBuild = jsonableObservable(S.value<string | null>(data && data.PlaceOfBuild !== undefined ? data.PlaceOfBuild : null));
        this.RawXml = jsonableObservable(S.value<string | null>(data && data.RawXml !== undefined ? data.RawXml : null));
        this.SpeedMax = jsonableObservable(S.value<string | null>(data && data.SpeedMax !== undefined ? data.SpeedMax : null));
        this.SpeedService = jsonableObservable(S.value<string | null>(data && data.SpeedService !== undefined ? data.SpeedService : null));
        this.SummerDwt = jsonableObservable(S.value<string | null>(data && data.SummerDwt !== undefined ? data.SummerDwt : null));
        this.VesselType = jsonableObservable(S.value<string | null>(data && data.VesselType !== undefined ? data.VesselType : null));
    }

    static key(obj : MarineTrafficResult) {
        return obj.Id();
    }
    
    static dataKey(obj : MarineTrafficResultOptions) {
        return obj.Id;
    }

    static update(obj : MarineTrafficResult, data : MarineTrafficResultOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.VesselServiceQueryId !== undefined) obj.VesselServiceQueryId(data.VesselServiceQueryId);
	        
            if (data.BreadthExtreme !== undefined) obj.BreadthExtreme(data.BreadthExtreme);
            if (data.Build !== undefined) obj.Build(data.Build);
            if (data.CallSign !== undefined) obj.CallSign(data.CallSign);
            if (data.CreatedOnUtc !== undefined) obj.CreatedOnUtc(new TZDate(data.CreatedOnUtc));
            if (data.DisplacementSummer !== undefined) obj.DisplacementSummer(data.DisplacementSummer);
            if (data.Draught !== undefined) obj.Draught(data.Draught);
            if (data.Flag !== undefined) obj.Flag(data.Flag);
            if (data.FuelConsumption !== undefined) obj.FuelConsumption(data.FuelConsumption);
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.IMO !== undefined) obj.IMO(data.IMO);
            if (data.LengthOverall !== undefined) obj.LengthOverall(data.LengthOverall);
            if (data.LiquidOil !== undefined) obj.LiquidOil(data.LiquidOil);
            if (data.Manager !== undefined) obj.Manager(data.Manager);
            if (data.MMSI !== undefined) obj.MMSI(data.MMSI);
            if (data.Name !== undefined) obj.Name(data.Name);
            if (data.Owner !== undefined) obj.Owner(data.Owner);
            if (data.PlaceOfBuild !== undefined) obj.PlaceOfBuild(data.PlaceOfBuild);
            if (data.RawXml !== undefined) obj.RawXml(data.RawXml);
            if (data.SpeedMax !== undefined) obj.SpeedMax(data.SpeedMax);
            if (data.SpeedService !== undefined) obj.SpeedService(data.SpeedService);
            if (data.SummerDwt !== undefined) obj.SummerDwt(data.SummerDwt);
            if (data.VesselType !== undefined) obj.VesselType(data.VesselType);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/MarineTrafficResult.ts